module.exports = __webpack_public_path__ + "static/form-1200-600-6f8e1b7bc40b21ebfcda67b5c310d6ab.png";